// types
import {
  AppointmentExceptionResponse,
  CreateAppointmentRequest,
  DeleteAppointmentRequest,
  UpdateAppointmentRequest
} from 'generated/index';
import { DialogProps } from '../types';
import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { Dispatch, SetStateAction } from 'react';

export enum SmartActionType {
  RECURRENCE_ACTION = 'RECURRENCE_ACTION',
  OVERLAP_ACTION = 'OVERLAP_ACTION'
}

export enum SmartActionState {
  NONE = 'NONE',
  ACTIVE = 'ACTIVE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export type SmartAction = {
  type: SmartActionType;
  enabled?: boolean;
  interactionType?: 'informational' | 'interactive';
  state?: SmartActionState;
  props?: Record<string, any>;
};

export type SmartActionComponentProps = {
  state?: SmartActionState;
  onSelect: <TProps extends { type: SmartActionType }>(props?: TProps) => void;
  setCanContinue: Dispatch<SetStateAction<boolean>>;
};

export type SmartActionDialogProps = DialogProps & {
  actionType?: 'update' | 'create' | 'delete';
  appointmentExceptions?: AppointmentExceptionResponse[];
  onExecuteAction?: <TResponse>(
    type: SmartActionType,
    props?: TResponse | any
  ) => void;
  onClose?: (props?: { ok: boolean }) => void;
  payload?: AppointmentFormFieldData;
};

export type AppointmentPayload = CreateAppointmentRequest &
  UpdateAppointmentRequest &
  DeleteAppointmentRequest;
